import axios from "axios"
import Cookies from 'js-cookie'
import { UPDATE_FOOD_QTY_IN_FOOD_ITEM, FETCH_RESTAURANT_FAILED, FETCH_RESTAURANT_REQUESTED, FETCH_RESTAURANT_SUCCEEDED } from "../constants"

const fetchRestaurantDetailsRequest = () => {
    return {
        type: FETCH_RESTAURANT_REQUESTED
    }
}

const fetchRestaurantDetailsSuccess = payload => {
    return {
        type: FETCH_RESTAURANT_SUCCEEDED,
        payload: payload
    }
}

const fetchRestaurantDetailsFailure = payload => {
    return {
        type: FETCH_RESTAURANT_FAILED,
        payload: payload
    }
}

export const updateFoodQuantity = payload => {
    return {
        type: UPDATE_FOOD_QTY_IN_FOOD_ITEM,
        payload: payload
    }
}


export const fetchRestaurantDetails = (payload) => {
    return function (dispatch) {
        dispatch(fetchRestaurantDetailsRequest());
        const jwtToken = Cookies.get("jwt_token");
        let url = `https://apis.ccbp.in/restaurants-list/${payload.id}`
        axios
            .get(url,
                {
                    'headers':
                    {
                        Authorization: `Bearer ${jwtToken}`,
                    },
                }
            )
            .then(response => {
                // response.data is the users
                response.data["food_items"].forEach(item => item.quantity = 1)
                dispatch(fetchRestaurantDetailsSuccess(response.data))
            })
            .catch(error => {
                // error.message is the error message
                dispatch(fetchRestaurantDetailsFailure(error.message))
            })
    }
} 